import React, { useCallback, useEffect, useState } from 'react';
import { Reporting } from './common/Reporting';
import { ActionButton } from './common/ActionButton';
import { useHistory, useParams } from 'react-router';
import { Token } from '../model/Model';
import { SiteHeader } from './common/SiteHeader';
import { Logo } from './common/Logo';
import { SiteStyle } from './common/SiteStyle';
import { Spacer } from './common/Spacer';
import { useCheckinState, useReportState } from '../state/state';
import { FetchSiteState } from './common/FetchSiteState';
import { WhenReady } from './common/WhenReady';

export const ChooseAction = () => {
    const { token } = useParams<Token>();
    const history = useHistory();
    const [ready, setReady] = useState(false);

    const {
        loading,
        loaded,
        activeCheckin,
        lastCheckin,
        fetch,
        reset,
    } = useCheckinState();
    const { reset: resetReport } = useReportState();

    useEffect(() => {
        reset();
        setReady(true);
    }, []);

    const onCheckin = useCallback(() => {
        if (token && resetReport) {
            resetReport();
            history.push(`/checkin/${token}`);
        }
    }, [token, resetReport]);

    const onCheckout = useCallback(() => {
        if (token && resetReport) {
            resetReport();
            fetch(token);
        }
    }, [token, resetReport]);

    useEffect(() => {
        if (ready && loaded && !loading) {
            if (activeCheckin) {
                history.push(`/checked/${token}`);
            }
            if (lastCheckin) {
                history.push(`/previous/${token}`);
            }
            if (!(activeCheckin || lastCheckin)) {
                history.push(`/search/${token}`);
            }
        }
    }, [ready, loaded, loading, activeCheckin, lastCheckin]);

    return (
        <>
            <FetchSiteState />
            <SiteStyle />
            <Reporting />
            <WhenReady>
                <Spacer height='4rem' />
                <SiteHeader />
                <Spacer height='4rem' />
                <ActionButton disabled={loading} text='Check In' onClick={onCheckin} />
                <ActionButton disabled={loading} text={loading ? 'Please wait...' : 'Check Out'}
                              invert={true} onClick={onCheckout} />
                <Spacer height='6rem' />
                <Logo />
            </WhenReady>
        </>
    );
};
